import { render, staticRenderFns } from "./ManageCourseCreate.vue?vue&type=template&id=537e884a&"
import script from "./ManageCourseCreate.vue?vue&type=script&lang=js&"
export * from "./ManageCourseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports